// Hook odpowiedzialny za zmianę statusu zamówienia (akceptacja/odrzucenie)

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

// typ zwracanych danych
type IResponse = ICommandResponseSuccess;

// typ danych wejściowych
export interface IRequest {
  status: 'accept' | 'reject';
}

const postOrderEditChangeStatus = (orderId: number, data: IRequest): Promise<IResponse> =>
  axios.post(`/order-edit/${orderId}/change-status`, data);

export const usePostOrderEditChangeStatus = (
  options?: UseMutationOptions<IResponse, IError, { orderId: number; data: IRequest }>
) => useMutation(({ orderId, data }) => postOrderEditChangeStatus(orderId, data), options);

